export default "__VITE_ASSET__YvwpnO57__"